<template>
<div class="chapter">
<div class="inner_page">
<a id="pviii"></a>
<div class="timebreak "> </div>
<div class="timebreak "> </div>
<div class="timebreak "> </div>
<div class="timebreak "> </div>
<blockquote>
<p class="center "><em>For their love and kindness during the writing of this book, I would like to thank my publisher, Cynthia Good, and my agent, Beverly Slopen, Michael Chadwick, Ann Kilcher, Lori Maruk and, most especially, my esteemed mentor, Mrs. Dianne Senechal.</em></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front03.vue?0b2b1f04